import React from "react";
import dynamic from "next/dynamic";

const AnyReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export default function RenderVideo({
  url,
  controls,
  variant = "video",
}: {
  url?: string;
  controls?: boolean;
  variant?: "video" | "story";
}) {
  const videoUrl = url ?? "https://www.youtube.com/watch?v=iGQ2-cipR9w";
  const containerClassName =
    variant === "story"
      ? "w-full max-w-[320px] md:max-w-[360px] aspect-[9/16]"
      : "w-full aspect-video";
  const wrapperClassName = `relative ${containerClassName} overflow-hidden rounded-2xl bg-black/70 ring-1 ring-white/10 shadow-[0_24px_60px_-36px_rgba(0,0,0,0.85)]`;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        marginBottom: 20,
      }}
      className={wrapperClassName}
    >
      <AnyReactPlayer
        height={"100%"}
        width={"100%"}
        controls={controls ?? false}
        style={{
          width: "100%",
          height: "100%",
        }}
        src={videoUrl}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-black/10" />
    </div>
  );
}
